import React, { createContext, useContext } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Word } from "./Word";
import { useDroppable } from "@dnd-kit/core";

export type BlanksState = Record<
  string,
  {
    value: string;
    correct?: boolean;
  }
>;

export const BlanksContext = createContext<{
  blanks: BlanksState;
  solutions: string[][];
}>({
  blanks: {},
  solutions: [],
});

type BlankProps = {
  id: number;
};

export function Blank({ id }: BlankProps) {
  const { isOver, setNodeRef, over } = useDroppable({ id });
  const { blanks } = useContext(BlanksContext);

  const isDraggingOver =
    isOver ||
    Object.entries(blanks).some(
      ([key, { value }]) =>
        key === id.toString() && value === over?.id.toString()
    );

  const blank = blanks[id];

  return (
    <Box
      ref={setNodeRef}
      d="inline-block"
      boxSizing="content-box"
      my="1"
      minW="40"
      h="10"
      rounded="md"
      borderWidth={1}
      borderColor={isDraggingOver ? "primary" : undefined}
    >
      <Flex align="center" justify="stretch" h="full">
        {blank ? (
          <Word w="full" isCorrect={blank.correct}>
            {blank.value}
          </Word>
        ) : (
          <span>&nbsp;</span>
        )}
      </Flex>
    </Box>
  );
}
